export default __webpack_public_path__ + "4c424d1560cc3bfcaad62cfd9e8a79ee.svg";